/*
Defines the custom element <ravel-a-stream>
*/

import { RavelAStream } from './src/RavelAStream.js';

customElements.define('ravel-a-stream', RavelAStream);
